import { usageActionTypes as actionTypes } from '../../ActionTypes/Voss/usageActionTypes';
import type { CustomerUsageOverview } from '../../Constants/VOSS/usageTypes';

export interface UsageReducerState {
    customerUsage: CustomerUsageOverview | null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type UsageAction = { type: string; data?: any };

const initialState: UsageReducerState = {
    customerUsage: null,
};

export default function UsageReducer(state: UsageReducerState = { ...initialState }, action: UsageAction): UsageReducerState {
    switch (action.type) {
        case actionTypes.STORE_CUSTOMER_USAGE:
            return { ...state, customerUsage: action.data as CustomerUsageOverview };
        case actionTypes.CLEAR_CUSTOMER_USAGE:
            return { ...initialState };
        default:
            return state;
    }
}
